import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class UuidService {
  /**
   * Gera um UUID v4.
   * @returns Uma string contendo o UUID.
   */
  public generateV4(): string {
    return uuidv4();
  }
}
